module.exports = __webpack_public_path__ + "img/config-1.1306450c.svg";